<pf-listview [items]="onSalePeriod ?? []" [title]="'onSalePeriod.title' | translate" [addRouterLink]="'/addproductsale'"
    [hasSearchSection]="true" [searchPlaceholder]="'onSalePeriod.searchPlaceholder' | translate">
    <ng-template #itemTemplate let-sale let-i="index">
        <div class="full-width-hover-row" [routerLink]="sale.routerLink"
            [class.single-item]="onSalePeriod?.length === 1">
            <div class="item-name">
                {{ sale.name }}
            </div>

            <div class="status-block">
            </div>
        </div>
    </ng-template>
</pf-listview>
